import { csrfFetch } from "./csrf.js";
import { gcoreServerUrl } from '../config';

const SET_MATERIAL_SLOTS = 'gmaterialSlot/setMaterialSlots';

const setMaterialSlots = (materialSlots) => ({
  type: SET_MATERIAL_SLOTS,
  payload: materialSlots,
});

export const selectAll = () => async dispatch => {
  const response = await csrfFetch(dispatch, `${gcoreServerUrl}/api/materialSlots`);
  const data = await response.json();
  dispatch(setMaterialSlots(data.materialSlots || []));
  return data.materialSlots || [];
};

export const create = (slot) => async dispatch => {
  const response = await csrfFetch(dispatch, `${gcoreServerUrl}/api/materialSlots`, {
    method: "POST",
    body: JSON.stringify(slot),
  });
  const data = await response.json();
  return data.materialSlot;
};

export const modify = (slot) => async dispatch => {
  const response = await csrfFetch(dispatch, `${gcoreServerUrl}/api/materialSlots`, {
    method: "PUT",
    body: JSON.stringify(slot),
  });
  const data = await response.json();
  return data.materialSlot;
};

export const remove = (id) => async dispatch => {
  const response = await csrfFetch(dispatch, `${gcoreServerUrl}/api/materialSlots/${id}`, {
    method: "DELETE",
  });
  return response;
};

const initialState = {
  materialSlots: [],
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_MATERIAL_SLOTS:
      return Object.assign({}, state, { materialSlots: action.payload });
    default:
      return state;
  }
}

export default reducer;
